<template>
  <div class="contact-item">
    <table>
      <tr>
        <td class="contactItemIcon" v-html="value.icon"></td>
        <td class="contactItemValue">
          <a
            v-if="value.href != null"
            class="contact underline"
            :href="value.href"
          >{{ value.value }}</a>
          <span v-if="value.href == null">{{ value.value }}</span>
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
export default {
  name: "ContactItem",
  props: {
    value: {
      icon: String,
      href: String,
      value: String
    }
  }
};
</script>
